import Vue from "vue";
import Vuex from "vuex";
import axios from "@/axios-client";
import apolloClient from "@/apollo-client";

Vue.use(Vuex);

export default new Vuex.Store({
  state: {
    isAuthenticated: false,
    profile: {},
  },

  getters: {
    isAuthenticated(state) {
      return state.isAuthenticated;
    },

    profile(state) {
      return state.profile;
    },
  },

  mutations: {
    AUTHENTICATED(state) {
      state.isAuthenticated = true;
    },
    LOGOUT(state) {
      state.isAuthenticated = false;
    },
    PROFILE(state, payload) {
      state.profile = payload;
    },
  },

  actions: {
    async login({ commit, dispatch }, { username, password }) {
      apolloClient.resetStore();
      return axios
        .post("/auth/login", { username, password })
        .then((response) => {
          if (response.status === 200) {
            commit("AUTHENTICATED");
          }
          return response;
        })
        .then(() => dispatch("me"));
    },

    async authenticate({ commit }, { accessToken }) {
      apolloClient.resetStore();
      return axios
        .post("/auth/authenticate", { access_token: accessToken })
        .then((response) => {
          if (response.status === 200) {
            commit("AUTHENTICATED");
          }
          return response;
        });
    },

    async logout({ commit }) {
      commit("LOGOUT");
      apolloClient.resetStore();
      return axios.get("/auth/logout")
    },

    async me({ commit }) {
      return axios
        .get("/me")
        .then((response) => {
          if (response.data.id) {
            commit("AUTHENTICATED");
            commit("PROFILE", response.data);
          }
          return response;
        })
        .catch(() => {
          commit("LOGOUT");
          apolloClient.resetStore();
        });
    },

    async resetPassword(foo, { email }) {
      return axios.post("/auth/reset", { email });
    },

    async changePassword(foo, { token, password, email }) {
      return axios.post("/auth/change-password", { token, password, email });
    },
  },
  modules: {},
});
